export default __webpack_public_path__ + "static/media/masan-hazir.c8728b74.svg";